"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionRank = void 0;
const web_consensus_1 = require("@branch-ts/web-consensus");
const subscriptionRank_html_R_1 = require("./subscriptionRank.html.R");
const subscriptionTier_1 = require("./subscriptionTier");
const versetUserProfileMechanism_1 = require("../versetUserProfileMechanism");
class SubscriptionRank extends subscriptionRank_html_R_1.R.SubscriptionRank {
    constructor(server) {
        super();
        this.server = server;
        this.ctx = web_consensus_1.RenderMechanism.about(this);
        this.workflow = web_consensus_1.WorkflowMechanism.about(this)
            .flow(() => {
            versetUserProfileMechanism_1.VersetUserProfileMechanism.events.of.refresh.listenBy(this, () => {
                void this.refresh();
            });
        })
            .unflow(() => {
            versetUserProfileMechanism_1.VersetUserProfileMechanism.events.stopListenBy(this);
            clearTimeout(this.expiryTimer);
        })
            .fetch(async (stale) => {
            const response = await this.server.rpcs.VersetUserSubscriptionService.getMySubscription({}).catch(error => {
                console.error("Could not check subscription tier", error);
                return null;
            });
            if (stale())
                return;
            clearTimeout(this.expiryTimer);
            const [result, reason] = response || [];
            const subscription = !reason ? result?.subscription : null;
            this.ctx.set("subscription", subscription);
            const expiresAt = (0, subscriptionTier_1.subscriptionTier)(subscription).expiresAt;
            if (expiresAt) {
                const expire = () => {
                    if (stale())
                        return;
                    this.ctx.set("subscription", subscription);
                    if (Date.now() < expiresAt) {
                        this.expiryTimer = setTimeout(expire, Math.min(expiresAt - Date.now(), 2_147_483_647));
                    }
                };
                this.expiryTimer = setTimeout(expire, Math.min(expiresAt - Date.now(), 2_147_483_647));
            }
        });
        this.present = web_consensus_1.PresentMechanism.ensure(this).lifeCycle(async (about) => {
            await about.declare("present");
            void this.refresh();
            await about.declare("hang");
            await about.declare("dismiss");
        });
        this.ctx.render(["subscription"], ({ subscription }) => {
            const tier = (0, subscriptionTier_1.subscriptionTier)(subscription);
            this.VM.tierName = tier.name;
            this.VM.tierClass = tier.className;
            this.node.title = `Current tier: ${tier.name}`;
        });
    }
    async refresh() {
        try {
            await this.workflow.refresh();
        }
        catch (error) {
            console.error("Could not refresh subscription tier", error);
        }
    }
}
exports.SubscriptionRank = SubscriptionRank;
